import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import Forms from './forms';
import Points from './points';
import Bar from './bar';
import { format, subDays } from 'date-fns';
import { getSummary, getAdv, getVisitors } from '@/api/dashboard/playturbo';

export default {
  components: {
    Forms: Forms,
    Points: Points,
    Bar: Bar
  },

  data: function data() {
    return {
      pickerOptions: {
        /* eslint-disable no-mixed-operators */
        shortcuts: [{
          text: '最近半个月',
          onClick: function onClick(picker) {
            var end = subDays(new Date(), 1);
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 16);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('form.pastMonth'),
          onClick: function onClick(picker) {
            var end = subDays(new Date(), 1);
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('form.past3Month'),
          onClick: function onClick(picker) {
            var end = subDays(new Date(), 1);
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 92);
            picker.$emit('pick', [start, end]);
          }
        }]
        /* eslint-disable no-mixed-operators */
      },
      date: '',
      activeName: 'date',
      formData: [],
      pointOptions: [],
      barOptions: [],
      advOptions: [],
      visitorFormData: [],
      advsFormData: [],
      advsFormHeader: [{ value: 'adv_name', label: '广告主' }, { value: 'tpl_cnt', label: '入驻模板' }, { value: 'ver_cnt', label: '输出版本' }],
      advsXlsxHeader: ['adv_name', 'tpl_cnt', 'ver_cnt'],
      vistorFormHeader: [{ value: 'adv_id', label: '广告主ID' }, { value: 'adv_name', label: '广告主名称' }, { value: 'cnt', label: '登录天数' }],
      visitorXlsxHeader: ['adv_id', 'adv_name', 'cnt']
    };
  },


  computed: {
    pointsData: function pointsData() {
      var _this = this;

      var flattenArray = [];
      var titleList = ['入驻广告主', '入驻模板数量', '产出版本数量'];
      var tipList = ['所有有授权制作模板的广告主的数量', '授权制作的模板数量', '广告主经过授权模板所产出的版本数量，包含删除'];
      this.pointOptions.forEach(function (item, index) {
        flattenArray.push({
          option: item,
          title: titleList[index],
          tip: tipList[index],
          total: item.series[0].data[item.series[0].data.length - 1],
          rise: riseNum(item.series[0].data),
          sdate: _this.date[0],
          edate: _this.date[1]
        });
      });
      // 计算上升率
      function riseNum(riseArray) {
        var rise = '0%';
        if (riseArray.length === 0) return rise;
        var tmp = (riseArray[riseArray.length - 1] - riseArray[0]) / riseArray[0] * 100;
        rise = tmp.toFixed(1) + '%';
        return rise;
      }
      return flattenArray;
    },
    barsData: function barsData() {
      var _this2 = this;

      var flattenArray = [];
      var titleList = ['广告主入驻模板前10名', '广告主产生版本前10名'];
      var tipList = ['授权制作的模板数量', '广告主经过授权模板所产出的版本数量，包含删除'];
      this.barOptions.forEach(function (item, index) {
        flattenArray.push({
          option: item,
          title: titleList[index],
          tip: tipList[index],
          edate: _this2.date[1]
        });
      });
      return flattenArray;
    },
    advsData: function advsData() {
      return {
        title: '登录用户数量统计',
        option: this.advOptions,
        edate: this.date[1]
      };
    }
  },

  watch: {
    date: {
      handler: function handler(val) {
        if (val === '') {
          var time = [format(subDays(new Date(), 16), 'YYYY-MM-DD'), format(subDays(new Date(), 1), 'YYYY-MM-DD')];
          this.date = time;
        } else {
          this.getData(); // 获取数据
          this.getVisitorData();
        }
        return val;
      },

      immediate: true,
      deep: true
    }
  },

  methods: {
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    },
    getAdvData: function getAdvData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getAdv();

              case 2:
                res = _context.sent;

                console.log(res);
                _this3.advsFormData = _.get(res, 'data.data.items');

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getData: function getData() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getSummary({
                  sdate: _this4.date[0],
                  edate: _this4.date[1]
                });

              case 2:
                res = _context2.sent;

                _this4.pointOptions = [_this4.cookPointOption(_.get(res, 'data.data.advs')), _this4.cookPointOption(_.get(res, 'data.data.tpls')), _this4.cookPointOption(_.get(res, 'data.data.vers'))];
                _this4.barOptions = [_this4.cookBarOption(_.get(res, 'data.data.adv_tpl_tops'), {
                  category: 'adv_name',
                  seriesData: 'cnt',
                  axis: 'y',
                  reverse: true
                }), _this4.cookBarOption(_.get(res, 'data.data.adv_ver_tops'), {
                  category: 'adv_name',
                  seriesData: 'cnt',
                  axis: 'y',
                  reverse: true
                })];

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    getVisitorData: function getVisitorData() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getVisitors({
                  sdate: _this5.date[0],
                  edate: _this5.date[1]
                });

              case 2:
                res = _context3.sent;

                _this5.advOptions = _this5.cookBarOption(_.get(res, 'data.data.stats'), {
                  category: 'date',
                  seriesData: 'cnt'
                });
                _this5.visitorFormData = _.get(res, 'data.data.visitors');

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },

    // 将数据加工成折线图表数据
    cookPointOption: function cookPointOption(data) {
      var xAxis = { data: [] };
      var series = [];
      var tmp = { data: [] };
      if (data) {
        data.forEach(function (item) {
          xAxis.data.push(item.date);
          tmp.data.push(item.cnt);
        });
      }
      series.push(tmp);
      return { xAxis: xAxis, series: series };
    },

    // 将数据加工为柱状图标数据
    cookBarOption: function cookBarOption(data, params) {
      params = _extends({
        category: '',
        seriesData: '',
        axis: 'x',
        reverse: false
      }, params);
      var axis = [];
      var series = [];
      var tmp = { data: [] };
      if (data) {
        data.forEach(function (item) {
          axis.push(item[params.category]);
          tmp.data.push(item[params.seriesData]);
        });
        if (params.reverse) tmp.data.reverse();
      }
      series.push(tmp);
      if (params.axis === 'x') {
        return { xAxis: { data: [].concat(axis), type: 'category' }, series: series };
      }
      return { yAxis: { data: [].concat(axis), type: 'category' }, series: series };
    }
  },

  mounted: function mounted() {
    this.getData();
    this.getVisitorData();
    this.getAdvData();
  }
};